import { http } from "../http/Http";
import { NLogRuleConfiguration } from "../models/NLogRuleConfiguration";

export class NLogRuleConfigurationService {
    getAll = async (): Promise<NLogRuleConfiguration[]> => {
        const { data } = await http.get<NLogRuleConfiguration[]>("NLogRuleConfiguration/GetAll");
        return data;
    };

    update = async (nLogRuleConfiguration: NLogRuleConfiguration): Promise<NLogRuleConfiguration> => {
        const { data } = await http.put<NLogRuleConfiguration>("NLogRuleConfiguration/Put", nLogRuleConfiguration);
        return data;
    };

    updateAll = async (enabled: boolean): Promise<NLogRuleConfiguration[]> => {
        const { data } = await http.put<NLogRuleConfiguration[]>("NLogRuleConfiguration/UpdateAll/" + enabled);
        return data;
    };
}